module.exports = __webpack_public_path__ + "media/images/landing/illust/choose-campaing-4fbd72bcd54e4e6bd16ad84490919046.png";